"use strict";
/*
* Created on Tue Oct 16 2018
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var WindowItemForecastConverter_1 = require("./conversion/WindowItemForecastConverter");

var WindowItemForecastConverterImpl_1 = require("./conversion/WindowItemForecastConverterImpl");

var WindowItemPostBaselineConverter_1 = require("./conversion/WindowItemPostBaselineConverter");

var WindowItemPostBaselineConverterImpl_1 = require("./conversion/WindowItemPostBaselineConverterImpl");

var WindowPromoEffectConverter_1 = require("./conversion/WindowPromoEffectConverter");

var WindowPromoEffectConverterImpl_1 = require("./conversion/WindowPromoEffectConverterImpl");

var WindowPromoEffectSiteConverter_1 = require("./conversion/WindowPromoEffectSiteConverter");

var WindowPromoEffectSiteConverterImpl_1 = require("./conversion/WindowPromoEffectSiteConverterImpl");
/**
 *
 */


var ForecastAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ForecastAppModule, _AppModule_1$AppModul);

  function ForecastAppModule() {
    var _this;

    _classCallCheck(this, ForecastAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'windowEffectAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(WindowPromoEffectConverter_1.WindowPromoEffectConverter).to(WindowPromoEffectConverterImpl_1.WindowPromoEffectConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowPromoEffectSiteConverter_1.WindowPromoEffectSiteConverter).to(WindowPromoEffectSiteConverterImpl_1.WindowPromoEffectSiteConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemForecastConverter_1.WindowItemForecastConverter).to(WindowItemForecastConverterImpl_1.WindowItemForecastConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemPostBaselineConverter_1.WindowItemPostBaselineConverter).to(WindowItemPostBaselineConverterImpl_1.WindowItemPostBaselineConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ForecastAppModule;
}(AppModule_1.AppModule);

exports.ForecastAppModule = ForecastAppModule;